import { CheckCircleOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";
import {
  BaseUser,
  DocumentVersion,
  DocumentVersionApprover,
} from "../../../../../stores/models";
import {
  formatDateTime,
  getApproverStatusText,
  getDocumentVersionAuthoredAt,
  userStatusDictionary,
} from "../utils";
import SectionContainer from "./SectionContainer";
import ApproverStatusChip from "./StatusChip";

export const CompleteScreen = ({
  approvers,
  revision,
  author,
  creator,
  documentCreatedAt,
  revisionSummary,
  docVersion,
}: {
  docVersion: DocumentVersion;
  approvers: DocumentVersionApprover[];
  revision: number;
  author: BaseUser;
  creator: BaseUser;
  documentCreatedAt: Date;
  revisionSummary: string;
}) => {
  const effectiveDate = docVersion.signatureTable?.effectiveAt;

  const formData = {
    assignedUsers: approvers,
    revisionSummary: revisionSummary,
  };

  const authoredAt = getDocumentVersionAuthoredAt({
    approvers,
    documentVersion: docVersion,
  });

  return (
    <div className="flex flex-col gap-2 pt-2 overflow-auto">
      <div className="flex items-center gap-2 my-2 border border-solid border-gray-200 rounded-md p-4 w-fit">
        <CheckCircleOutlined color="success" />
        <Typography variant="body1" className="font-bold">
          {`Revision ${revision} received full approval and was released${effectiveDate ? ` on ${formatDateTime(effectiveDate)}` : "."}`}
        </Typography>
      </div>
      <div className="flex flex-col gap-4">
        <SectionContainer
          title="Created by"
          content={
            <ApproverStatusChip
              person={creator}
              text={`Created on ${formatDateTime(documentCreatedAt)}`}
              color="default"
            />
          }
        />
        <SectionContainer
          title="Author"
          content={
            <ApproverStatusChip
              person={author}
              text={`Authored on ${formatDateTime(authoredAt)}`}
              color="success"
            />
          }
        />
        <SectionContainer
          title="Approvers"
          content={
            <div className="flex gap-3 w-full">
              {Object.values(formData.assignedUsers).map(
                (approver) =>
                  approver && (
                    <ApproverStatusChip
                      person={approver.user}
                      key={approver.id}
                      color={
                        userStatusDictionary[approver.approvalStatus].variant
                      }
                      text={getApproverStatusText(approver)}
                    />
                  )
              )}
            </div>
          }
        />
        <SectionContainer
          title="Revision Summary"
          content={
            <Typography fontSize="body2">{formData.revisionSummary}</Typography>
          }
        />
      </div>
    </div>
  );
};

export default CompleteScreen;
